import type {
  PlaybookScoreCriterionComparesCondition,
  PlaybookScoreCriterionEqualsCondition,
} from "@repo/app-types/entities/filterConditions";
import type { PlaybookId } from "@repo/app-types/entities/playbook";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { Collection, SubmenuTrigger } from "react-aria-components";
import { LabeledAssessmentScore } from "../insights/assessmentScore.js";

export interface PlaybookScoreCriterionConditionMenuProps {
  playbookId: PlaybookId;
  criterionId: string;
  onSelect: (
    condition:
      | PlaybookScoreCriterionEqualsCondition
      | PlaybookScoreCriterionComparesCondition,
  ) => void;
}

const operatorOptions: readonly {
  id: string;
  label: string;
  operator: (
    | PlaybookScoreCriterionEqualsCondition
    | PlaybookScoreCriterionComparesCondition
  )["operator"];
}[] = [
  { id: "=", label: "is equal to...", operator: "=" },
  { id: "<", label: "is less than...", operator: "<" },
  { id: "<=", label: "is less than or equal to...", operator: "<=" },
  { id: ">=", label: "is greater than or equal to...", operator: ">=" },
  { id: ">", label: "is greater than...", operator: ">" },
];

const valueOptions: readonly {
  id: string;
  value: (
    | PlaybookScoreCriterionEqualsCondition
    | PlaybookScoreCriterionComparesCondition
  )["value"];
}[] = [
  { id: "1", value: 1 },
  { id: "2", value: 2 },
  { id: "3", value: 3 },
  { id: "4", value: 4 },
  { id: "5", value: 5 },
];

export const PlaybookScoreCriterionConditionMenu: FC<
  PlaybookScoreCriterionConditionMenuProps
> = (props) => {
  return (
    <SimpleMenu aria-label="Score criterion condition">
      <Collection items={operatorOptions}>
        {(operatorOption) => (
          <SubmenuTrigger>
            <SimpleMenuItem>{operatorOption.label}</SimpleMenuItem>

            <SimpleMenuPopover>
              <SimpleMenu aria-label="Score value">
                <Collection items={valueOptions}>
                  {(valueOption) => (
                    <SimpleMenuItem
                      onAction={() =>
                        props.onSelect({
                          playbookId: props.playbookId,
                          criterionId: props.criterionId,
                          gradingValueType: "1_5_score",
                          operator: operatorOption.operator,
                          value: valueOption.value,
                        })
                      }
                    >
                      <LabeledAssessmentScore score={valueOption.value} />
                    </SimpleMenuItem>
                  )}
                </Collection>
              </SimpleMenu>
            </SimpleMenuPopover>
          </SubmenuTrigger>
        )}
      </Collection>
    </SimpleMenu>
  );
};
